<div
  class="store-grade-card"
  [ngClass]="{
    'fullpage-store-grade-card': isNewPage && isFullScreen,
    'store-grade-card-fullScreen': !isNewPage && isFullScreen
  }"
  [ngStyle]="{ 'background': badge.color }">
  <div class="content-container">
    <div class="grade-container"
         [ngStyle]="{ 'background': badge.color, 'color': badge.textColor }">
      <div class="grade-text">{{ label }}</div>
      <div class="grade-label">Overall Store Grade</div>
    </div>
  </div>
</div>
